export const employeesRole = {
	table: {
		roleName: "Nombre del cargo",
		access: "Acceso",
		collaboratorsQuantity: "Cantidad de colaboradores en el cargo",
		none: "Ninguno",
	},
	masterOperationPDVAndDashboard: "Master - Operación (PDV) y Dashboard",
	operationPDV: "Operación (PDV)",
	dashboard: "Dashboard",
	roleNeedsASlug: "El cargo necesita un slug",
	collaborators: "Colaboradores",
	collaborator: "Colaborador",
	editRole: "Editar cargo",
	deleteRole: "Eliminar cargo",
	newRole: "Nuevo cargo",
	noneCollaborator: "Ningún colaborador",
	deleteRoleModal: {
		title: "¿Desea eliminar el cargo?",
		describe:
			"Al eliminar un cargo, todos los colaboradores vinculados a él pierden el vínculo.",
	},
	rolePermissionWarning:
		"Este cargo tiene permisos de dash y PDV y por eso no puede ser usado en la edición/creación de empleados",
	header: {
		roles: "Cargos",
		describe:
			"Agregue, edite y elimine cargos para ser utilizados en el dashboard o en el PDV",
		searchRole: "Buscar cargo",
		searchRolePlaceholder: "Busque por nombre del cargo",
		closeSearch: "Cerrar búsqueda",
		alertMessage:
			"A partir de la separación de empleados en dash y PDV ya no es posible crear o usar cargos con permisos de ambos tipos.",
	},
	roleModal: {
		PDVRole: "Operación",
		PDVDescription: "Cargo para colaboradores con permiso de acceso a <b>PDVs</b>",
		PDVFooterText: "Crear colaborador PDV",
		enterpriseRole: "Gerencial",
		enterpriseDescription:
			"Cargo para colaboradores con permiso de acceso al <b>Dashboard</b>",
		enterpriseFooterText: "Crear colaborador dash",
		newManagerRole: "Nuevo cargo gerencial",
		newOperationRole: "Nuevo cargo de operación",
		operationPermission: "Permisos operacionales",
		managerPermission: "Permisos gerenciales",
		paymentPermission: "Métodos de pago",
	},
	form: {
		roleNameDescription: "Seleccione el tipo de cargo que desea crear",
		roleNameRequired: "El nombre del cargo es obligatorio",
		roleName: "Nombre del cargo",
		roleNamePlaceholder: "Ingrese el nombre del nuevo cargo",
		roleNameError: "Nombre del cargo inválido",
		importExistingRolePermissions: "(Opcional) Importar permisos de cargo existente",
		selectExistingRole: "Seleccione un cargo existente",
		roleType: "Tipo del cargo",
		roleTypeDisabledWithCollaborators: "Este cargo ya tiene colaboradores vinculados",
		operational: "PDV",
		managerial: "Dashboard",
		master: "Master",
		saveEditions: "Guardar cambios",
		createNewRole: "Crear nuevo cargo",
		discardChanges: "Descartar cambios",
		discardCreation: "Descartar creación",
	},
};
